export const LOGS_SISTEMA_LISTAR_LOGS_RPA_BEGIN = 'LOGS_SISTEMA_LISTAR_LOGS_RPA_BEGIN';
export const LOGS_SISTEMA_LISTAR_LOGS_RPA_SUCCESS = 'LOGS_SISTEMA_LISTAR_LOGS_RPA_SUCCESS';
export const LOGS_SISTEMA_LISTAR_LOGS_RPA_FAILURE = 'LOGS_SISTEMA_LISTAR_LOGS_RPA_FAILURE';
export const LOGS_SISTEMA_LISTAR_LOGS_RPA_DISMISS_ERROR = 'LOGS_SISTEMA_LISTAR_LOGS_RPA_DISMISS_ERROR';
export const LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_BEGIN = 'LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_BEGIN';
export const LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_SUCCESS = 'LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_SUCCESS';
export const LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_FAILURE = 'LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_FAILURE';
export const LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_DISMISS_ERROR = 'LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/logs-sistema/redux/constants.js